import React, { useContext, useState } from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { Auth } from "../../utils/AuthContext";
import Firebase from '../../utils/firebaseConfig';

import '../../assets/css/patrocinadoresNuevos.css';

// 🔥 IMPORTS
import img_logo_1 from '../../assets/images/2026/Patrocinadores/ies_AcuityBrands.png';
import img_logo_3 from '../../assets/images/2026/Patrocinadores/ies_Construlita.png';
import img_logo_4 from '../../assets/images/2026/Patrocinadores/ies_Current.png';
import img_logo_5 from '../../assets/images/2026/Patrocinadores/ies_Lamp.png';
import img_logo_6 from '../../assets/images/2026/Patrocinadores/ies_Ledvance.png';
import img_logo_7 from '../../assets/images/2026/Patrocinadores/ies_LjIluminacion.png';
import img_logo_8 from '../../assets/images/2026/Patrocinadores/ies_Lutron.png';
import img_logo_10 from '../../assets/images/2026/Patrocinadores/ies_Performance.png';

import img_logo_11 from '../../assets/images/2026/Patrocinadores/ies_Siecled.png';
import img_logo_12 from '../../assets/images/2026/Patrocinadores/ies_Signify.png';
import img_logo_13 from '../../assets/images/2026/Patrocinadores/ies_Zeraus.png';

// 🔥 LIMPIO (sin index innecesario)
const logos = [
  { img: img_logo_1, nombre: 'acuity-brands', url:'/patrocinadores/acuity-brands', activo:false },
  { img: img_logo_3, nombre: 'construlita', url:'/patrocinadores/construlita', activo:false },
  { img: img_logo_4, nombre: 'current', url:'/patrocinadores/current', activo:false },
  { img: img_logo_11, nombre: 'ilumileds', url:'/patrocinadores/ilumileds', activo:false },
  { img: img_logo_5, nombre: 'lamp', url:'/patrocinadores/lamp', activo:false },
  { img: img_logo_6, nombre: 'ledvance', url:'/patrocinadores/ledvance', activo:false },
  { img: img_logo_12, nombre: 'ljiluminacion', url:'/patrocinadores/ljiluminacion', activo:false },
  { img: img_logo_7, nombre: 'lutron', url:'/patrocinadores/lutron', activo:false },
  { img: img_logo_8, nombre: 'signify', url:'/patrocinadores/signify', activo:false },
  { img: img_logo_13, nombre: 'tridonic', url:'/patrocinadores/tridonic', activo:false },
  { img: img_logo_10, nombre: 'zeraus', url:'/patrocinadores/zeraus', activo:false },
];

const CarouselPatrocinadores2 = () => {

  const app = new Firebase();
  const { usuario, datos } = useContext(Auth);
  const [dia] = useState(1);
  const nombre_evento = 'ies-2023';

  const almacenarClicStand = (nombre_pat) => {
    const metrica = { dia, ...datos };

    if(usuario){
      app.verificar_objeto_dia(
        `${nombre_evento}/stands/${nombre_pat}/stand`,
        'correo',
        datos.correo,
        dia,
        (data) => {
          if(!data){
            app.escribir(`${nombre_evento}/stands/${nombre_pat}/stand`, undefined, metrica, ()=>{});
          }
        }
      );
    } else {
      app.escribir(`${nombre_evento}/stands/${nombre_pat}/stand_clic`, undefined, { clic:1, dia }, ()=>{});
    }
  };

  return (
   <>
  <div className="patrocinadores_section">

      <h3 className="titulo">Patrocinadores</h3>

      <Row justify="center" gutter={[20, 20]}>
        {logos.map((logo, index) => (
          <Col key={index} xs={12} sm={8} md={6} lg={4}>
            
            <div className="logo_card">

              {logo.activo ? (
                <Link onClick={() => almacenarClicStand(logo.nombre)} to={logo.url}>
                  <img src={logo.img} alt={logo.nombre} />
                </Link>
              ) : (
                <a href="https://iesmexico.org/"><img src={logo.img} alt={logo.nombre} /></a>
              )}

            </div>

          </Col>
        ))}
      </Row>

    </div>
   </>
  );
};

export default CarouselPatrocinadores2;